/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Destructive_Confirm_InertInputs */



/**
* | output |
* | --- |
* | "Asks for approval anyway at its current confirmation level" |
*
* @param {Agent_Policy_Destructive_Confirm_InertInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_destructive_confirm_inert = /** @type {((inputs?: Agent_Policy_Destructive_Confirm_InertInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Destructive_Confirm_InertInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fragt auf seiner aktuellen Bestätigungsstufe trotzdem nach Freigabe")
	return /** @type {LocalizedString} */ ("Asks for approval anyway at its current confirmation level")
});